import React, {useState, useEffect, useRef} from 'react';
import {Form, Modal} from 'antd';
import emiter, {
    _EVENTS,
} from '../../../../events';
import BatchSettings from './batch-settings'
import {useCarModelPrice} from "../../../../hooks/product-price/car-model-price";

type CommonGlobalPropsVO = {
    enums?: any
}

// @ts-ignore
const SPModal: React.FC<CommonGlobalPropsVO> = props => {
    const { enums, } = props
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [title, setTitle] = useState('');
    const dataRef = useRef({});
    const configRef: any = useRef({});

    const { prodBatchEditFn } = useCarModelPrice();

    const submitProcessPrice = (data: any) => {
        if (!data) return data
        if (!isNaN(Number(data.deposit_broken))) {
            data.deposit_broken = data.deposit_broken * 100
        }
        if (!isNaN(Number(data.deposit_illegal))) {
            data.deposit_illegal = data.deposit_illegal * 100
        }

        if (!isNaN(Number(data?.price_detail?.weekday?.price))) {
            data.price_detail.weekday.price = data?.price_detail?.weekday?.price * 100
        }

        if (!isNaN(Number(data?.price_detail?.weekend?.price))) {
            data.price_detail.weekend.price = data?.price_detail?.weekend?.price * 100
        }
        return data
    }

    const openModal = (params: any) => {
        dataRef.current = params || {};
        form.resetFields();
        setOpen(true);
        setDisabled(!!params.disabled);
        setTitle('批量设置');
    };

    const onClose = () => {
        form.resetFields();
        dataRef.current = {}
        setOpen(false);
        setDisabled(false);
        form.resetFields();
        setTitle('');
    };

    const onOk = () => {

        form
            .validateFields()
            .then(async (values) => {
                const data = form.getFieldsValue();
                prodBatchEditFn(submitProcessPrice(data))
                onClose()
            })
            .catch(() => {});
    };


    useEffect(() => {
        emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.OPEN_MODEL, openModal);
        return () => {
            emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.OPEN_MODEL)
        }
    }, []);

    return (
        open && <Modal zIndex={1001} title={title} width={'70%'} centered open={open} onOk={onOk} onCancel={onClose}>
            <Form form={form} labelCol={{ span: 8 }} disabled={disabled} >
                <BatchSettings form={form} enums={enums}></BatchSettings>
            </Form>
        </Modal>
    );
};

export default SPModal;
